<template>
  <div>
    <v-card class="mt-4 pt-2 pb-2" flat>
      <v-card-actions>
        <v-select
          v-model="SelStatus"
          :items="StatusName"
          item-text="event_name"
          item-value="event_id"
          label="Select Event"
          dense
          :rules="[(v) => !!v || 'Event is required']"
          required
          return-object
          @change="clearData"
          hide-details
          full-width
        ></v-select>
        <v-btn color="primary" class="ml-3" raised dark large @click="load">
          RELOAD1
        </v-btn>
        <v-btn
          color="success"
          class="ml-3"
          raised
          dark
          large
          @click="savechanges"
        >
          SAVE CHANGES
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-row>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Choose Card(s)</v-card-text>

          <v-data-table
            v-model="selected"
            :headers="hdrreason"
            :items="arrreason"
            item-key="card_id"
            dense
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Search"
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <v-btn
                    fab
                    small
                    dark
                    color="green"
                    outline
                    class="ma-1"
                    @click="editItem_BY(item)"
                  >
                    <v-icon center>mdi-plus</v-icon>
                  </v-btn>
                </td>

                <td>{{ item.card_id }}</td>
                <td>{{ item.card_name }}</td>
              </tr>
            </template>

            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Selected Cards(s)</v-card-text>
          <v-data-table
            :headers="hdr1reason"
            :items="arr1reason"
            item-key="card_id"
            dense
            :loading="loading"
            :search="search1"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search1"
                label="Search"
                single-line
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <v-btn
                    fab
                    small
                    dark
                    outline
                    color="red"
                    class="ma-1"
                    @click="editItem_TO(item)"
                  >
                    <v-icon center>mdi-delete</v-icon>
                  </v-btn>
                </td>
                <td>{{ item.card_id }}</td>
                <td>{{ item.card_name }}</td>
                <td>
                  <v-text-field
                    v-model="item.card_capacity"
                    required
                    hide-details
                    dense
                  ></v-text-field>
                </td>
               
                 <td><v-checkbox  v-model="item.local"></v-checkbox></td>
                <td><v-checkbox v-model="item.central"></v-checkbox></td>
                <td><v-checkbox v-model="item.media"></v-checkbox></td> 
                   <!-- <td><v-checkbox  v-model="checkbox1"></v-checkbox></td>
                <td><v-checkbox v-model="checkbox2"></v-checkbox></td>
                <td><v-checkbox v-model="checkbox3"></v-checkbox></td> -->
              </tr>
            </template>

            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({

     checkbox1: 1,
         checkbox2: 1,
         checkbox3: 1,
    successstatus: "primary",
    i: 0,
    i_flag: "NEW",
    index: 0,
    snackbar: false,
    snackbartext: "",
    snackbarcolor: "primary",
    loading: false,
    checkbox: "",
    chkselected: "",
    selected: [],
    StatusName: [],
    SelStatus: "",
    search: "",
    search1: "",
    btrue: true,

    l: "",
    c: "",
    m: "",
    // inputCardtype:{
    //     l: "N",
    //     c: "N",
    //     m: "N"
    // },
    inputclass: {
      eid: "",
      ctype: [],
    },

    arrreason: [],
    hdrreason: [
      { text: "SELECT" },
      { text: "ID", value: "card_id" },
      { text: "CARD NAME", value: "card_name" },
    ],

    arr1reason: [],
    hdr1reason: [
      { text: "SELECT" },
      { text: "ID", value: "card_id" },
      { text: "SELECTED CARD", value: "card_name" },
      { text: "OPNING QTY", value: "card_capacity" },
      { text: "Local", value: "local" },
      { text: "Central", value: "central" },
      { text: "Media", value: "media" },
    ],

    editedItem: {
      card_id: "",
      card_name: "",
      card_capacity: "0",
      event_id: "",
      mapping_status: "",
    },
  }),
  mounted() {
    this.bindcompanytype();
    // this.Gridbindjobtype();
    // this.Gridbindjobtype(4);
  },
  watch: {
    selected: function () {},
    bindcompanytype: function () {},
  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },

    addvalue: function (id, name, cid, status) {
      //alert(id + " " + name + " " + cid + " " + status);

      console.log(status);
      this.editedItem.reason_id = id;
      this.editedItem.reason_name = name;
      this.editedItem.status_id = cid;
      this.editedItem.mapping_status = "true";
      (this.editedItem.card_capacity = "0"),
        this.arr1reason.push(this.editedItem);
      //  this.arr1jobtype.splice()
    },
    clearData: function () {
      this.arrreason = [];
      this.selected = [];
    },

    editItem_BY: function (item) {
      //  this.inputclass.cid = [];
      // this.arr1reason=[];
      this.successstatus = "success";
      this.i_flag = "";
      this.i_flag = "NEW";
      this.editedItem = [];
      this.editedItem.card_id = item.card_id;
      this.editedItem.card_name = item.card_name;
      this.editedItem.card_capacity = "0";
      if (this.arr1reason.length == 0) {
        this.arr1reason.push(this.editedItem);
        this.arrreason.splice(this.arrreason.indexOf(item), 1);
      } else {
        for (this.i = 0; this.i <= this.arr1reason.length - 1; this.i++) {
          // alert(this.arr1reason[this.i]["card_id"] + "/" + item.card_id);
          if (this.arr1reason[this.i]["card_id"] == item.card_id) {
            this.i_flag = "EXIST";
            return;
          }
        }

        //alert(this.i_flag);
        if (this.i_flag == "NEW") {
          this.arr1reason.push(this.editedItem);
          this.arrreason.splice(this.arrreason.indexOf(item), 1);
        }
      }
      //this.selected = this.arrreason.filter(
      //   (task) => task.card_id == this.inputclass.cid
      // );
    },

    editItem_TO: function (item) {
      this.editedItem = [];
      this.editedItem.card_id = item.card_id;
      this.editedItem.card_name = item.card_name;

      this.arr1reason.splice(this.arr1reason.indexOf(item), 1);
      this.arrreason.push(this.editedItem);
      //  this.selected = this.arrreason.filter(
      //             (task) => task.card_id == this.inputclass.cid
      //           );
    },

    load: function () {
      //alert(SelStatus.)
      //  alert(this.SelStatus.event_name);
      this.selected = [];
      this.loading = true;
      this.Gridbindjobtype(this.SelStatus.event_id);
    },
    savechanges: function () {
      if (this.arr1reason.length <= 0) {
        this.showSnackbar("error", "Select Card before save !");
        return;
      }
      
    //  this.inputclass.cid = [];
     // this.inputclass.cc = [];
      this.inputclass.ctype = [];
      this.arr1reason.forEach((el) => {
        this.l="";
        this.c="";
        this.m="";
       // this.inputclass.cid.push(el.card_id);
       // this.inputclass.cc.push(el.card_capacity);
        if (el.local == "true" || el.local == true) {
          this.l = "Y";
        } else {
          this.l = "N";
        }

        if (el.central == "true" || el.central == true) {
          this.c = "Y";
        } else {
          this.c = "N";
        }

        if (el.media == "true" || el.media == true) {
          this.m = "Y";
        } else {
          this.m = "N";
        }

        // this.inputclass.ctype.push({
        //   l: el.local == (true || "true") ? "Y" : "N",
        //   c: el.central == (true || "true") ? "Y" : "N",
        //   m: el.media == (true || "true") ? "Y" : "N",
        // });

 this.inputclass.ctype.push({
          cid:el.card_id,cc:el.card_capacity,l:this.l,c:this.c,m:this.m
        });

      });
      this.inputclass.eid = this.SelStatus.event_id;
      console.log("try input");
      console.log(this.inputclass);
      axios
        .post(this.$apiPath + "Event_Card", this.inputclass, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          if (res.data.status == "Success") {
            this.showSnackbar("Success", "Card and  Event merged !");
            this.Reload();
          }
        })
        .catch()
        .finally();
    },

    handleClick(value) {
      alert(value);
    },
    bindcompanytype: async function () {
      await axios
        .get(this.$apiPath + "Event", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.StatusName = res.data.result;
        })
        .catch()
        .finally();
    },

    Gridbindjobtype: async function (comid) {
      await axios
        .get(this.$apiPath + "Event_Card/GetMappingByEventId/" + comid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          console.log(res.data.result);
          this.arrreason = res.data.result;
          //  this.arr1reason = res.data.result;
          this.arr1reason = this.arrreason.filter(
            (task) => task.event_id == this.SelStatus.event_id
          );

          this.arrreason = this.arrreason.filter(
            (n) => !this.arr1reason.includes(n)
          );
        })
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>